import React from 'react';
import { getPlayerNameColor } from '../../utils/playerUtils';
import { isOpponentNamedMatchupEvent } from '../../services/activityFeedService';

function OpponentName({ name, gender }) {
  const display = name || 'your opponent';
  return <span className={getPlayerNameColor(gender)}>{display}</span>;
}

/**
 * Headline for matchup activity events with gender-coloured opponent names.
 */
export function MatchupEventHeadline({ event }) {
  const { event_type, metadata } = event;
  if (!isOpponentNamedMatchupEvent(event_type)) return null;

  const name = metadata?.opponent_first_name;
  const gender = metadata?.opponent_gender ?? null;
  const w = metadata?.player_wins ?? 0;
  const l = metadata?.opponent_wins ?? 0;
  const last4 = metadata?.last4_wins ?? 3;
  const m30 = metadata?.matches_30d ?? 4;
  const total = metadata?.total_matches ?? 0;

  switch (event_type) {
    case 'matchup_first_win':
      return (
        <>
          First win vs <OpponentName name={name} gender={gender} />: now {w}–{l}
        </>
      );
    case 'matchup_tied':
      return (
        <>
          All square with <OpponentName name={name} gender={gender} />: now {w}–{w}
        </>
      );
    case 'matchup_took_lead':
    case 'rivalry_swing':
      if (w === l) {
        return (
          <>
            You and <OpponentName name={name} gender={gender} /> are all square: now {w}–{l}
          </>
        );
      }
      return (
        <>
          You moved ahead vs <OpponentName name={name} gender={gender} />: now {w}–{l}
        </>
      );
    case 'matchup_hot_form':
      return (
        <>
          Strong run vs <OpponentName name={name} gender={gender} />: Won {last4} of your last 4 games
        </>
      );
    case 'matchup_frequent_recent':
      return (
        <>
          You&apos;ve seen <OpponentName name={name} gender={gender} /> a lot lately: {m30} games this month
        </>
      );
    case 'rivalry_heated':
      return (
        <>
          You and <OpponentName name={name} gender={gender} /> are evenly matched: {w}–{l} across {total} games
        </>
      );
    case 'rivalry_nemesis':
      return (
        <>
          A familiar matchup vs <OpponentName name={name} gender={gender} />: you&apos;re {w}–{l} this season
        </>
      );
    case 'rivalry_dominated':
      return (
        <>
          Strong record vs <OpponentName name={name} gender={gender} />: {w}–{l} this season
        </>
      );
    case 'rivalry_emerging':
      return (
        <>
          You and <OpponentName name={name} gender={gender} /> are building a history: {w}–{l} so far
        </>
      );
    default:
      return null;
  }
}
